import { PaginationRequest } from 'Types/Pagination'

export const buildPaginationQueryString = (pagination?: PaginationRequest) => {
  const queryParams: Record<string, string> = {}
  if (pagination?.page) {
    const { page, search, limit } = pagination
    queryParams['page'] = String(page)
    if (limit) queryParams['limit'] = String(limit)
    if (search) queryParams['search'] = String(search)
  }

  return 'page' in queryParams ? '?' + new URLSearchParams(queryParams).toString() : ''
}
